import { PropsWithChildren } from 'react';

type Props = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  circle?: boolean;
};

export const Checkbox = (props: PropsWithChildren<Props>) => {
  return (
    <div
      className="flex items-center gap-[15px] cursor-pointer w-auto h-fit"
      onClick={() => props.onChange?.(!props.checked)}
    >
      <div
        className={`w-[20px] h-[20px] ${props.circle ? 'rounded-full' : 'rounded-[5px]'} flex items-center justify-center border border-[#33455F] ${props.checked ? 'bg-[#007AFE]' : 'bg-transparent'}`}
      >
        {props.checked &&
          (props.circle ? (
            <div className="w-[8px] h-[8px] rounded-full bg-white" />
          ) : (
            <svg
              fill="none"
              height="10"
              viewBox="0 0 13 10"
              width="10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.6249 9.76255L0.743652 5.8813L2.5124 4.11255L4.6249 6.2313L10.7999 0.0500488L12.5687 1.8188L4.6249 9.76255Z"
                fill="white"
              />
            </svg>
          ))}
      </div>
      {props.children ? (
        <span className="text-[12px] text-white">{props.children}</span>
      ) : null}
    </div>
  );
};
